var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1044_45109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 14.1667V15.8334C3.33398 16.2754 3.50958 16.6994 3.82214 17.0119C4.1347 17.3245 4.55862 17.5001 5.00065 17.5001H15.0007C15.4427 17.5001 15.8666 17.3245 16.1792 17.0119C16.4917 16.6994 16.6673 16.2754 16.6673 15.8334V14.1667",
    stroke: "#2D3643",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.167 7.5L10.0003 3.33333L5.83366 7.5",
    stroke: "#2D3643",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333L10 3.33334",
    stroke: "#2D3643",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1044_45109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.00e293f62ca0dee5df4dfcd63e305441.svg";
export { ForwardRef as ReactComponent };